import { Component, OnInit } from '@angular/core';
import { NavBarComponent } from '../nav-bar/nav-bar.component';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css']
})
export class TermsComponent implements OnInit {
  navOptions = NavBarComponent.standard;
  version = "1.0.0";
  constructor() { }

  ngOnInit() {
  }

}
